import stylesheet0 from "@oneappexchange/appx-font-utilities";
import stylesheet1 from "@oneappexchange/appx-grid";
import stylesheet2 from "@oneappexchange/appx-reset";

function stylesheet(token, useActualHostSelector, useNativeDirPseudoclass) {
  var shadowSelector = token ? ("[" + token + "]") : "";
  var hostSelector = token ? ("[" + token + "-host]") : "";
  var suffixToken = token ? ("-" + token) : "";
  return ".error-img" + shadowSelector + " {padding-bottom: var(--sds-g-spacing-4);min-width: 100px;max-width: 500px;width: 100%;margin: 0 auto;}.container-inner" + shadowSelector + " {padding: var(--sds-g-spacing-12) var(--sds-g-spacing-6) var(--sds-g-spacing-6);min-width: 320px;}.container-text" + shadowSelector + " {text-align: center;}.container-text" + shadowSelector + " p" + shadowSelector + " {padding-top: var(--sds-g-spacing-2);max-width: 576px;align-self: center;}";
  /*LWC compiler v7.1.3*/
}
export default [stylesheet0, stylesheet1, stylesheet2, stylesheet];